import { HStack } from '@cbhq/cds-web/layout';
import { TextTitle2 } from '@cbhq/cds-web/typography';

import { useGetDashboard } from ':cloud/hooks/useGetDashboard';
import { DashboardRangeDropdown } from ':cloud/widgets/monitoring/DashboardRangeDropdown';

export function DashboardHeader() {
  const { dashboard } = useGetDashboard();
  return (
    <HStack justifyContent="space-between" alignItems="center" spacingBottom={4}>
      <TextTitle2 as="h1">{dashboard?.title || 'Project activity'}</TextTitle2>

      <HStack alignItems="center" gap={1}>
        <DashboardRangeDropdown />
      </HStack>
    </HStack>
  );
}
